import { render } from "./ReefBottom.vue?vue&type=template&id=fa7e5ba0"
import script from "./ReefBottom.vue?vue&type=script&lang=js"
export * from "./ReefBottom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__